import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isCustomerBrowseEnabled } from '../config/customerFeatureFlags.js';
import { useCustomerFeatureFlags } from '../features/flags/useCustomerFeatureFlags.js';
import { resolvePlatformHubPath } from '../features/shop/resolveShopHref.js';

interface CustomerBrowseRouteGuardProps {
  readonly children: ReactNode;
  readonly loadingFallback: ReactNode;
}

/**
 * Boot-only gate for platform `/browse` — redirects when Nakupovat is disabled.
 */
export function CustomerBrowseRouteGuard({
  children,
  loadingFallback,
}: CustomerBrowseRouteGuardProps): JSX.Element {
  const { flags, flagsReady } = useCustomerFeatureFlags();

  if (!flagsReady) {
    return <>{loadingFallback}</>;
  }

  if (!isCustomerBrowseEnabled(flags)) {
    return <Navigate to={resolvePlatformHubPath(flags)} replace />;
  }

  return <>{children}</>;
}
